/* eslint-disable @angular-eslint/no-input-rename */
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { computed } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';

import { MobileNavService } from '../../../../core/services/mobile-nav';
import { Permission } from '../../../constants/permissions';
import { SharedModule } from '../../../shared.module';
import { getCurrentUser, State } from '../../../../store';

@Component({
  selector: 'app-widget-summary-display',
  templateUrl: './widget-summary-display.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [SharedModule, CommonModule],
})
export class WidgetSummaryDisplayComponent {
  Permission = Permission;

  @Input() billingAddress: string;

  @Input() accountName: string;

  @Input() currentBalance: number | null | undefined;

  @Input() isCreditBalance: boolean | null | undefined;

  @Input() lastPaymentDate: Date | string | null | undefined;

  @Input() lastPaymentAmount: number | null | undefined;

  @Input() loading: boolean = true;

  private readonly store = inject(Store<State>);
  private readonly mobileNavService = inject(MobileNavService);

  user = toSignal<any>(this.store.select(getCurrentUser));
  isSwitchingAccount = this.mobileNavService.isSwitchingAccount;

  hasMultipleAccounts = computed(() => (this.user()?.Accounts?.length ?? 0) > 1);

  openAccountSwitcher(): void {
    this.mobileNavService.openAccountSwitcher();
  }
}
